import axios, { AxiosInstance } from "axios";
import { ENV } from "../env/env";

/*
 * Main Axios Instance with base url
 */

const axiosPublic: AxiosInstance = axios.create({
  baseURL: ENV.API_ENDPOINT,
  headers: {
    post: {
      Accept: "application/json",
    },
    get: {
      Accept: "application/json",
    },
  },
  withCredentials: true,
});

/*
 * External Axios Instance for external API calls (no base URL)
 */
const axiosExternal: AxiosInstance = axios.create({
  headers: {
    post: {
      Accept: "application/json",
    },
    get: {
      Accept: "application/json",
    },
  },
  withCredentials: true,
});

export default axiosPublic;
export { axiosExternal };
